import request from '@/http/zhaocai'
import {userApi, recruitmentInfoUrl} from '@/utils/zhaocai/config.js'
const api = process.env.VUE_APP_APIMATERIALS
const pinyin = process.env.VUE_APP_LOGISTICS
const urlMember = process.env.VUE_APP_APIUSER
const urlLg = process.env.VUE_APP_LOGINAPI //

let SyncToken = process.env.VUE_APP_SYNC_TOKEN
let authurltype = process.env.VUE_APP_API_LOGIN
export const apiHome = {
    // 地区
    // getArea: async function() {
    // 	return new Promise((resolve, reject) => {
    // 		axios({
    // 			method: 'get',
    // 			url: `https://api.gcw.net:8787/index/getCurrentProvince`
    // 		})
    // 			.then(res => {
    // 				resolve(res)
    // 			})
    // 			.catch(err => {
    // 				reject(err)
    // 			})
    // 	})
    // },
    // 热词
    //   getHotKey: async function () {
    //     return new Promise((resolve, reject) => {
    //       axios({
    //         method: 'get',
    //         url:`/search/getHotkeys`
    //       })
    //         .then(res => {
    //           resolve(res)
    //         })
    //         .catch(err => {
    //           reject(err)
    //         })
    //     })
    //   },
    getIdentifiers:() => request.get(`${urlLg}/authentication/sv1/user`),//用户权限
    getSMSLoginCode: (data) => request.post(`${process.env.VUE_APP_API_LOGIN}/ov1/sms`, data), // 获取验证码
    getArea: () => request.get('/api/area/list'), // 地区
    getHotKey: () => request.get('/api/search/getHotKey'), // 热词
    // fetchBannerList: () => request.get('/api/font/banner/1/10'), // 首页banner图
    fetchBannerList: (data) => request.get(`banner/v2/front/${data}`), // 首页banner图

    getAllIndexList: (params)=> request.get(`${process.env.VUE_APP_SERVERNAME_JYBUSERPAGE}/v1/index/getAllIndexList`, params),//首页企业列表

    fetchTeamCategory: () => request.get('/api/font/category'), // 获取招采类目
    getNewRecruitmentItems: () => request.get('/api/font/newproject'), // 获取最新招采项目
    getExcellenceCompanys: () => request.get('/api/font/newcompany'), // 获取优质企业
    fetchRecommendedTalent: () => request.get('/api/index/getRecommendTalent'), // 获取推荐人才
    fetchRecommendTeam: () => request.get('/api/index/getRecommendTeam'), // 获取推荐工队
    // fetchRecommendCompany: () => request.get('/api/index/getRecommendCompany'), // 获取推荐企业
    getMenuList: () => request.get(process.env.VUE_APP_APIMENU), // 获取菜单

    //获取推荐/成员/会员企业列表
    getCompanyList: (data) => request.get(`/sv1/admin/allSiteInfo/companyRecommend/${data}`),
		//获取意见反馈所属板块
		getPlate: async (data) => {
			return new Promise(async (resolve, reject) => {
				request.get(api + '/siteFeedback/plateSelect', data).then(res => {
					resolve(res)
				})
					.catch(err => {
						reject(err)
					})
			})
		},
		//提交反馈意见
		siteFeedback: async function (data) {
			return new Promise((resolve, reject) => {
				request.post(api + `/siteFeedback`, data)
					.then(res => {
						resolve(res)
					})
					.catch(err => {
						reject(err)
					})
			})
    },
    // 关注/取消关注
    attentionHandle: async (data) => {
      return new Promise(async (resolve, reject) => {
        request.post(`${userApi}/api/userFocus`, data).then(res => {
          resolve(res)
        })
          .catch(err => {
            reject(err)
          })
      })
    },
    InvitedForm: (params) => request.post(`${process.env.VUE_APP_API}` + '/ov1/member/league/inviteComJoin', params),
    //经营类型
    getmanageaType: () => request.get(urlMember+`/v2/api/companyInfo/getServiceTypeList`),
    //新的城市api
    getNewCityList: (params) => request.get(`${pinyin}/area/pinyinSearch`, params),

    //
    searchEnterprise: (params) => request.get(urlMember + '/userJoinCompanyAudit/searchComList', params), // 搜索企业

    saveUserTokenToRedis: async function () {
        console.log(`${SyncToken}` + "/tokensync/saveUserTokenToRedis");
      return new Promise((resolve, reject) => {
        request
          .get(`${SyncToken}` + "/tokensync/saveUserTokenToRedis", {}, {
            withCredentials: true
          })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
     // 获取banner广告
    getBannerAdverList: async function (data) {
      return new Promise((resolve, reject) => {
        request
          .get(`${process.env.VUE_APP_LOGINAPI}`+'/jyb-advertisement/app/banner/getAdv', data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取顶部广告
    getTopAdverList: async function (data) {
      return new Promise((resolve, reject) => {
        request
          .get(`${process.env.VUE_APP_LOGINAPI}` + '/jyb-advertisement/app/top/getAdv', data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取侧边广告
    getSliderAdverList: async function (data) {
      return new Promise((resolve, reject) => {
        request
          .get(`${process.env.VUE_APP_LOGINAPI}`+'/jyb-advertisement/app/homePageSide/getAdv', data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    sendLogout: async function (data) {
        return new Promise((resolve, reject) => {
          request
            .get(`${authurltype}`+'/logout')
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      memberUser: async function (data) {
        return new Promise((resolve, reject) => {
          request
            .getLogin(`${authurltype}`+'/v1/user/memberUser/me')
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
}
